import { render, staticRenderFns } from "./EWUserActivityLimitForm.vue?vue&type=template&id=9f667128&"
import script from "./EWUserActivityLimitForm.vue?vue&type=script&lang=js&"
export * from "./EWUserActivityLimitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports